import { Device } from "@nms-ng2/app/modules/device/device-backup/device-backup.models";
import { Subject } from "rxjs";
import { WebSocketSubject } from "rxjs/webSocket";

/*
 * Percentuais do andamento do polling. Existem outros percentuais, mas apenas esses são necessários aqui.
 */
export const POLLING_PERCENTAGES = {
    FINISHED: 100,
    ERROR: -1
};

/*
 * Status possíveis do polling de um equipamento.
 */
export const POLLING_STATUS = {
    SUCCESS: "SUCCESS",
    FAIL: "FAIL",
    RUNNING: "RUNNING"
};

/*
 * Modelo que representa um feedback de polling.
 * É retornado dessa forma pelo serviço device-management-web com o objeto PayloadPollingFeedback.
 */
export interface PollingFeedback {
    percentage: number;
    resourceId: number;
    description: string;
    processDetails: string;
    payload: Device;
}

/*
 * Armazena os dados necessários para gerenciar o estado do polling de um equipamento.
 */
export class DevicePollingData {

    finishedPollingListener: Subject<PollingFeedback>;
    finished: boolean;
    lastFeedback: PollingFeedback;

    constructor(public websocket: WebSocketSubject<PollingFeedback>) {
        this.finishedPollingListener = new Subject<PollingFeedback>();
        this.finished = false;
    }
}
